(function () {
  function initProduct(root) {
    if (root.dataset.igInit) return;
    root.dataset.igInit = '1';

    var form = root.querySelector('[data-ig-form]');
    if (!form) return;

    var qtyInput = root.querySelector('[data-ig-qty-input]');
    var dec = root.querySelector('[data-ig-dec]');
    var inc = root.querySelector('[data-ig-inc]');
    var variantSelect = root.querySelector('[data-ig-variant-select]');
    var variantIdInput = root.querySelector('[data-ig-variant-id]');
    var priceEl = root.querySelector('[data-ig-price]');
    var addBtn = root.querySelector('[data-ig-add]');
    var addLabel = root.querySelector('[data-ig-add-label]');
    var mainImage = root.querySelector('[data-ig-main-image]');
    var addUrl = form.getAttribute('data-add-url') || '/cart/add.js';

    // Quantity stepper (clamp at 1)
    function clamp() {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyInput.value = v;
      return v;
    }
    if (dec) dec.addEventListener('click', function () { qtyInput.value = Math.max(1, clamp() - 1); });
    if (inc) inc.addEventListener('click', function () { qtyInput.value = clamp() + 1; });
    if (qtyInput) qtyInput.addEventListener('change', clamp);

    // Variant selection → update hidden id + price
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        variantIdInput.value = variantSelect.value;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      });
    }

    // Gallery thumbnails → swap main image
    root.querySelectorAll('[data-ig-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImage && thumb.dataset.full) mainImage.src = thumb.dataset.full;
        root.querySelectorAll('[data-ig-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // AJAX add to cart
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var originalLabel = addLabel ? addLabel.textContent : '';
      addBtn.disabled = true;

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantIdInput.value, quantity: clamp() })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && res.data.description) || 'Add to cart failed');
          if (addLabel) addLabel.textContent = 'Added ✓';
          addBtn.classList.add('is-added');
          emberBurst(addBtn);
          refreshCartCount();
          setTimeout(function () {
            if (addLabel) addLabel.textContent = originalLabel;
            addBtn.classList.remove('is-added');
            addBtn.disabled = false;
          }, 1600);
        })
        .catch(function (err) {
          if (addLabel) addLabel.textContent = 'Unavailable';
          setTimeout(function () {
            if (addLabel) addLabel.textContent = originalLabel;
            addBtn.disabled = false;
          }, 1600);
          console.warn('[ig-product]', err);
        });
    });
  }

  /* A short shower of embers off the button. Fires only on a confirmed add, so it
     reads as a reward rather than ambient motion. */
  function emberBurst(btn) {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var rect = btn.getBoundingClientRect();
    var layer = document.createElement('div');
    layer.className = 'ig-embers';
    layer.style.left = rect.left + rect.width / 2 + 'px';
    layer.style.top = rect.top + rect.height / 2 + 'px';
    for (var i = 0; i < 14; i++) {
      var e = document.createElement('span');
      e.className = 'ig-ember';
      e.style.setProperty('--dx', (Math.random() * 2 - 1) * (rect.width * 0.55) + 'px');
      e.style.setProperty('--dy', -(60 + Math.random() * 70) + 'px');
      e.style.setProperty('--s', (0.5 + Math.random() * 0.9).toFixed(2));
      e.style.animationDelay = (Math.random() * 140).toFixed(0) + 'ms';
      layer.appendChild(e);
    }
    document.body.appendChild(layer);
    setTimeout(function () { layer.remove(); }, 1400);
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ig-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-ig-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
